<script>
import Dialog from 'element-ui/lib/dialog';

export default Dialog;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/dialog.css';

.el-dialog {
  &__footer {
    text-align: inherit;
  }

  & &__close {
    color: $wet-asphalt;
  }

  .row {
    max-width: none;
  }

  &__body {
    word-break: normal;
  }

  @include breakpoint(small only) {
    width: calc(100% - #{map_get($grid-column-gutter, small)}) !important;

    &__header {
      padding-bottom: 10px;
    }

    &__body {
      padding-top: 10px;
      padding-bottom: 10px;
      overflow-x: hidden;
      overflow-y: auto;
      max-height: calc(100vh - 170px);
      width: 100%;
    }
  }

  @include breakpoint(medium only) {
    width: calc(100% - #{map_get($grid-column-gutter, medium)}) !important;
  }

  @include breakpoint(large up) {
    min-width: 400px;
  }

  @include rtl() {
    &__headerbtn {
      left: 20px;
      right: auto;
    }
  }
}
</style>
